var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "1400" },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { short: "", dark: "", color: "primary" } },
            [
              _c(
                "v-btn",
                { attrs: { icon: "", dark: "" }, on: { click: _vm.cancel } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _c("v-toolbar-title", [_vm._v(" Create Driver ")])
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.requiredRule],
                              label: "Driver Id"
                            },
                            model: {
                              value: _vm.newDriver.driverId,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "driverId", $$v)
                              },
                              expression: "newDriver.driverId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "User Id" },
                            model: {
                              value: _vm.newDriver.userId,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "userId", $$v)
                              },
                              expression: "newDriver.userId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.requiredRule],
                              label: "Company Id"
                            },
                            model: {
                              value: _vm.newDriver.companyId,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "companyId", $$v)
                              },
                              expression: "newDriver.companyId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.requiredRule],
                              label: "Fleet Id"
                            },
                            model: {
                              value: _vm.newDriver.fleetId,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "fleetId", $$v)
                              },
                              expression: "newDriver.fleetId"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.requiredRule],
                              label: "First Name"
                            },
                            model: {
                              value: _vm.newDriver.firstName,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "firstName", $$v)
                              },
                              expression: "newDriver.firstName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.requiredRule],
                              label: "Last Name"
                            },
                            model: {
                              value: _vm.newDriver.lastName,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "lastName", $$v)
                              },
                              expression: "newDriver.lastName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.emailRule, _vm.requiredRule],
                              label: "Email"
                            },
                            model: {
                              value: _vm.newDriver.email,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "email", $$v)
                              },
                              expression: "newDriver.email"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.phoneNumberRule, _vm.requiredRule],
                              label: "Phone Number"
                            },
                            model: {
                              value: _vm.newDriver.phoneNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.newDriver, "phoneNumber", $$v)
                              },
                              expression: "newDriver.phoneNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { staticClass: "ml-2", on: { click: _vm.create } }, [
                _vm._v(" Create ")
              ]),
              _c("v-btn", { staticClass: "ml-2", on: { click: _vm.cancel } }, [
                _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")
              ]),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }